import * as React from 'react';
import { ExclusiveBrandsItem, ExclusiveBrands } from '@grandvisionhq/content';
import { Heading } from '@grandvisionhq/elements';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/state';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBloomreachPageable } from '../../hocs/with-bloomreach-pageable.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsExclusiveBrandsItem = withEditableContent(({ content  })=>{
    const [link] = useBloomreachLinks([
        {
            url: content.url
        }
    ]);
    if (!content.brandLogo) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ExclusiveBrandsItem, {
        url: link.url,
        title: content.title,
        logoSrc: content.brandLogo.url
    });
});
const CmsBrandCollection = ({ content , template  })=>{
    switch(template){
        case 'exclusive-brands':
            return /*#__PURE__*/ React.createElement(ExclusiveBrands, null, content.items.map((brand)=>/*#__PURE__*/ React.createElement(CmsExclusiveBrandsItem, {
                    key: brand.id,
                    content: brand
                })
            ));
        default:
            return /*#__PURE__*/ React.createElement(Heading, {
                variant: "subheading1"
            }, "Banner of type ", template, " not defined in BrandCollection");
    }
};
var BrandCollection = compose(withBreakpointVisibility, withHidableContent, withBloomreachPageable, withAnchor)(CmsBrandCollection);

export { CmsBrandCollection, BrandCollection as default };
//# sourceMappingURL=BrandCollection.js.map
